<div class="sig-container m-0 p-0">
    <div class="w-100 m-0 p-0 mb-0">
        <button class="pos-a-l" mat-stroked-button color="accent" (click)="clear()">Clear</button>
        <small class="italics pos-a-r mr-1 font-weight-lighter">Electronic Signature</small>
        <canvas [ngClass]="scrollable ? 'canvas lightgray mb-0 w-100' : 'canvas minty mb-0 w-100'" #signaturePad
            (mousedown)="drawmode(true); setPosition($event)" (mousemove)="draw($event)" (mouseup)="drawmode(false)"
            (pointerdown)="drawmode(true); setPosition($event)" (pointermove)="draw($event)" (pointerup)="drawmode(false)">
        </canvas>
    </div>
    <div class="col-12 row m-0 p-0 mt-0">
        <div class="col-2 m-0 p-0">
            <button class="w-100 btn-danger backbtn" mat-flat-button (click)="captureCanvas('exit')">
                <mat-icon>arrow_left</mat-icon>
            </button>
        </div>
        <div class="col-10 m-0 p-0">
            <button class="w-100 mr-4 pr-4 acceptbtn" mat-flat-button (click)="captureCanvas()">Accept</button>
        </div>
    </div>
</div>